import React from 'react';

export function ArrowDownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
    >
      <path
        d="M7.45102 9.42215C7.75772 9.74795 8.25499 9.74795 8.56169 9.42215L15.77 1.76499C16.0767 1.43918 16.0767 0.910951 15.77 0.585147C15.4633 0.259344 14.966 0.259343 14.6593 0.585147L8.00082 7.65828L1.33401 0.576305C1.02884 0.252126 0.534055 0.252125 0.228881 0.576304C-0.0762951 0.900483 -0.0762951 1.42608 0.228881 1.75026L7.45102 9.42215Z"
        fill="#008254"
      />
    </svg>
  );
}
